import { CopyIcon } from '@radix-ui/react-icons'
import { copy } from '@/utils/copy'
import { toast } from 'sonner'

export const Copy = ({ content }: { content: string }) => {
  return (
    <CopyIcon
      className={'cursor-pointer'}
      onClick={() => {
        copy(content)
        toast.success('Copied to clipboard')
      }}
    />
  )
}
